import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { authHttpClient } from '../../../../../core/infra/http/axios-auth-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { VerifyCnpjAvailability } from './verify-cnpj-availability';

export const verifyCnpjAvailabilityService: ServiceCommand<VerifyCnpjAvailability.Response> =
  new VerifyCnpjAvailability(authHttpClient, AUTH_API_ROUTES.VERIFY_CNPJ_AVAILABILITY);

export type { VerifyCnpjAvailability };
